import { Observable, of } from 'rxjs'
import { map, switchMap, take, withLatestFrom } from 'rxjs/operators'
import { AppState } from 'src/app/core/core.state'
import { Component, Input, OnInit } from '@angular/core'
import { Store } from '@ngrx/store'
import { Member } from '../../member/member'
import { Participation } from '../participation/participation'
import { TemplateTypes } from '../../email-template/email-template'
import { participationSelectors } from '../participation/participation.selectors'
import { bookingSelectors } from '../booking.selectors'
import { Booking } from '../booking'
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy'

@UntilDestroy()
@Component({
  selector: 'booking-communication-tab',
  templateUrl: './show.component.html',
  styleUrls: ['./show.component.scss']
})
export class BookingCommunicationTabComponent implements OnInit {
  @Input() participants: Participation[]
  @Input() bookingId: number
  public booking$: Observable<Booking>

  public participations$: Observable<Participation[]>
  public selectableMembers$: Observable<Member[]>
  public templateTypes = TemplateTypes
  public bookingSelectors = bookingSelectors
  constructor(private store: Store<AppState>) {}

  ngOnInit() {
    if (!this.participants) {
      const bookingId$ = this.bookingId
        ? of(this.bookingId)
        : this.store
            .select(bookingSelectors.selectIdRouteParam)
            .pipe(map((id) => Number(id)))

      this.booking$ = bookingId$.pipe(
        switchMap((id) => this.store.select(bookingSelectors.selectById, id)),
        untilDestroyed(this)
      )
    } else if (this.bookingId) {
      this.booking$ = this.store.select(
        bookingSelectors.selectById,
        this.bookingId
      )
    }

    this.participations$ = this.booking$.pipe(
      withLatestFrom(this.store.select(participationSelectors.selectEntities)),
      map(
        ([booking, participationEntities]) =>
          booking?.participations?.map((pId) => participationEntities[pId]) ??
          []
      ),
      untilDestroyed(this)
    )
  }
}
